import { gql } from '@apollo/client';

export const INSTANT_REVIEW_CLICK_MUTATION = gql`
    mutation instantReviewSocialClick($id: ID!, $reviewId: ID!) {
        instantReviewSocialClick (id: $id, reviewId: $reviewId) {
          id
        }
    }
`